/**
 * Partners Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import Swal from "sweetalert2";
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";
// States
const state = {
    Partners: [],
    Partner: {}
};

// Getters
const getters = {
    Partners: state => {
        return state.Partners
    },

    Partner: state => {
        return state.Partner
    }
};

// Actions
const actions = {
    getPartners(context, payload) {
        function successCallback(response) {
            context.commit('getPartnersHandler', { Partners: response.data.partenaires });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Partner.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getPartner(context, payload) {
        function successCallback(response) {
            context.commit('getPartnerHandler', { Partner: response.data.partenaire });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Partner.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createPartner(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('message')){
                Swal.fire(
                    response.data.message,
                    '',
                    'warning'
                );
            }
            router.push({ name: 'partner', params: { partner: response.data.partenaire.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.Partner.Create, localToken, successCallback, errorCallback, payload.errorMessages);
        let url = AppConfig.apiUrl + apiModel.Partner.Create.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
        },

    updatePartner(context, payload) {
        function successCallback(response) {
          
            store.dispatch('findAndRemove', {name: 'partner' });
            router.push({ name: 'partner', params: { partner: response.data.partenaire.slug } });

        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

         makeApiRequest(payload.args, apiModel.Partner.Update, localToken, successCallback, errorCallback, payload.errorMessages);

      /*  let url = AppConfig.apiUrl + apiModel.Partner.Update.url + '/' + payload.partner;

        Vue.axios.put(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);*/
    },

    deletePartner(context, payload) {
        function successCallback(response) {
            router.push({ name: 'Partners' });
            //    context.commit('deletePartnerHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Partner.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getPartnersHandler(state, { Partners }) {
        // Update Partners state
        state.Partners = Partners;
    },
    getPartnerHandler(state, { Partner }) {
        // Update Partner state
        state.Partner = Partner;
    },

    deletePartnerHandler(state, { index, successMessage }) {
        let i = state.Partners.findIndex(Partner => Partner.slug === index);

        if (~i) {
            state.Partners.splice(i, 1);

            router.push({ name: 'Partners' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}